import { computed, watch, onMounted, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, mergeProps, createBlock, createCommentVNode, renderSlot, toDisplayString, createTextVNode } from 'vue';
import propTypes from './utils/prop-types';
import { FOCUS_EVENT, BLUR_EVENT, CHANGE_EVENT, INPUT_EVENT, CLICK_EVENT, RIGHT_CLICK_EVENT, CLEAR_EVENT } from './utils/constants';
import { createComponent } from './utils/create-component';
import Icon from './icon';
import { useInputModel } from './utils/hooks/use-input-model';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  type: propTypes.string().def('text'),
  size: propTypes.string().def('mini'),
  border: propTypes["boolean"]().def(false),
  disabled: propTypes["boolean"]().def(false),
  readonly: propTypes["boolean"]().def(false),
  autocomplete: propTypes.string().def(''),
  autofocus: propTypes["boolean"]().def(false),
  modelValue: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  placeholder: propTypes.string().def('请输入'),
  maxlength: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  showWordLimit: propTypes["boolean"]().def(false),
  showArrow: propTypes["boolean"]().def(false),
  clearable: propTypes["boolean"]().def(false)
};
var emits = [FOCUS_EVENT, BLUR_EVENT, CHANGE_EVENT, INPUT_EVENT, CLICK_EVENT, RIGHT_CLICK_EVENT, CLEAR_EVENT];

var _createComponent = createComponent('input'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: _defineProperty({}, Icon.name, Icon),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var _useInputModel = useInputModel(props, emit),
      inputValue = _useInputModel.inputValue,
      inputRef = _useInputModel.inputRef,
      inputProps = _useInputModel.inputProps,
      _useInputModel$effect = _useInputModel.effects,
      onFocus = _useInputModel$effect.onFocus,
      onBlur = _useInputModel$effect.onBlur,
      onClick = _useInputModel$effect.onClick,
      onInput = _useInputModel$effect.onInput,
      onCompositionStart = _useInputModel$effect.onCompositionStart,
      onCompositionEnd = _useInputModel$effect.onCompositionEnd,
      setInputValue = _useInputModel$effect.setInputValue;
    function onRightIconClick(e) {
      emit(RIGHT_CLICK_EVENT, e);
    }
    function onClear() {
      emit(CHANGE_EVENT, '');
      emit(INPUT_EVENT, '');
      emit(CLEAR_EVENT);
    }
    var inputClass = computed(function () {
      var _ref2;
      return ["".concat(className, " ").concat(className, "-").concat(props.size), (_ref2 = {}, _defineProperty(_ref2, "".concat(className, "-disabled"), props.disabled), _defineProperty(_ref2, "".concat(className, "-border"), props.border), _ref2)];
    });
    var showClose = computed(function () {
      return props.clearable && inputValue.value.length;
    });
    watch(inputValue, function () {
      setInputValue();
    });
    onMounted(function () {
      setInputValue();
    });
    return {
      inputValue: inputValue,
      className: className,
      slots: slots,
      inputClass: inputClass,
      inputRef: inputRef,
      inputProps: inputProps,
      showClose: showClose,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      onRightIconClick: onRightIconClick,
      onInput: onInput,
      onCompositionStart: onCompositionStart,
      onCompositionEnd: onCompositionEnd,
      onClear: onClear
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.inputClass),
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.onClick && _ctx.onClick.apply(_ctx, arguments);
    })
  }, [createElementVNode("input", mergeProps({
    ref: "inputRef",
    "class": "".concat(_ctx.className, "__input")
  }, _ctx.inputProps, {
    onFocus: _cache[0] || (_cache[0] = function () {
      return _ctx.onFocus && _ctx.onFocus.apply(_ctx, arguments);
    }),
    onBlur: _cache[1] || (_cache[1] = function () {
      return _ctx.onBlur && _ctx.onBlur.apply(_ctx, arguments);
    }),
    onInput: _cache[2] || (_cache[2] = function () {
      return _ctx.onInput && _ctx.onInput.apply(_ctx, arguments);
    }),
    onCompositionstart: _cache[3] || (_cache[3] = function () {
      return _ctx.onCompositionStart && _ctx.onCompositionStart.apply(_ctx, arguments);
    }),
    onCompositionend: _cache[4] || (_cache[4] = function () {
      return _ctx.onCompositionEnd && _ctx.onCompositionEnd.apply(_ctx, arguments);
    })
  }), null, 16 /* FULL_PROPS */), _ctx.showClose ? (openBlock(), createBlock(_component_sp_icon, {
    key: 0,
    ref: "clearRef",
    name: "baseflat_cdeletetext_24",
    size: "20",
    onClick: _ctx.onClear
  }, null, 8 /* PROPS */, ["onClick"])) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "right", {}, function () {
    return [_ctx.showWordLimit && _ctx.maxlength ? (openBlock(), createElementBlock("div", {
      key: 0,
      "class": normalizeClass("".concat(_ctx.className, "__right"))
    }, [createElementVNode("span", {
      "class": normalizeClass(_defineProperty({}, "".concat(_ctx.className, "__word-limit-tips"), _ctx.inputValue.length >= _ctx.maxlength))
    }, toDisplayString(_ctx.inputValue.length), 3 /* TEXT, CLASS */), createTextVNode(" /" + toDisplayString(_ctx.maxlength), 1 /* TEXT */)], 2 /* CLASS */)) : _ctx.showArrow ? (openBlock(), createBlock(_component_sp_icon, {
      key: 1,
      "class": normalizeClass("".concat(_ctx.className, "__right")),
      name: "base_next_24",
      onClick: _ctx.onRightIconClick
    }, null, 8 /* PROPS */, ["class", "onClick"])) : createCommentVNode("v-if", true)];
  })], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/input/input.vue";

var _Input = script;

export { _Input as default };
